export type Range = {
  min: number
  max: number
}

export type RangeWithArray = {
  min: number
  max: number
  otherOptions: number[]
}

export enum AddOnTypes {
  MULTIPLIER = 'MULTIPLIER',
  EXTRA_DRAWS = 'EXTRA_DRAWS',
  MINI_GAME = 'MINI_GAME',
}
